import uamClientService from '../../services/uam/uamClientService';
import * as uamActionStatusTypes from './uamActionStatusTypes';
import {log} from '../../services/log';
import * as uamFlowTypes from './uamFlowTypes';
import {selectIsConnectInProgress} from '../../state/selectors/iotData';
import {
    setAutoCleanInProgress,
    setConnectInProgress,
    setFindMyDeviceStatus,
    setFwuInProgress,
    setResetDeviceInProgress,
    setUpdateSettingsInProgress,
} from '../../state/slices/iotData';
import * as iotConnectionService from '../../services/iot/iotConnectionService';
import errorService from '../../services/errors/errorService';
import {MW_ERRORS} from '../app/mwErrors';
import findMyDeviceStatuses from '../device/findMyDeviceStatuses';

const checkRequestStatus = async ({isHolder, requestId, type, isTimeout}) => {
    if (!requestId || !type) return true;

    const {status, error, endTime} = await uamClientService.checkUamRequestStatus(requestId, isHolder);
    const endTimeTS = endTime ? new Date(endTime) : new Date();

    if (status === uamActionStatusTypes.PENDING) return false;

    log.info(
        `checkRequestStatus: request is checked with status ${status} for requestId ${requestId} isHolder: ${isHolder}`
    );
    await updateRequestStatusRelatedFlow({status, error, endTimeTS, type, isHolder, isTimeout});

    return true;
};

const getCustomError = (isSuccess, isTimeout, error) => {
    const errorMessage = JSON.stringify(error) || 'Error is not defined in IoT response';
    const customError = isTimeout
        ? errorService.createError(MW_ERRORS.ERROR_IOT_CONNECTION_TIMEOUT, 'Flow Timeout')
        : errorService.createError(MW_ERRORS.ERROR_IOT_CUSTOM, errorMessage);

    return isSuccess ? undefined : customError;
};

const updateRequestStatusRelatedFlow = async ({status, error, endTimeTS, type, isHolder, isTimeout}) => {
    const isSuccess = status === uamActionStatusTypes.SUCCESS;
    const customError = getCustomError(isSuccess, isTimeout, error);

    switch (type) {
        case uamFlowTypes.RESET_DEVICE:
            setResetDeviceInProgress(isHolder, false, customError);
            break;
        case uamFlowTypes.FIND_MY_DEVICE:
            const findMyDeviceStatus = isSuccess ? findMyDeviceStatuses.SUCCESS : findMyDeviceStatuses.ERROR;

            //endTimeTs - time when setting was completed on cm side so this is start time for MW
            setFindMyDeviceStatus(findMyDeviceStatus, customError, endTimeTS);
            break;
        case uamFlowTypes.UPDATE_SETTINGS:
            setUpdateSettingsInProgress(isHolder, false, customError);
            break;
        case uamFlowTypes.AUTO_CLEAN:
            setAutoCleanInProgress(false, customError);
            break;
        case uamFlowTypes.UPDATE_FIRMWARE:
            setFwuInProgress(isHolder, false, customError);
            break;
        case uamFlowTypes.SYNCHRONIZE:
            const isSyncInProgress = selectIsConnectInProgress(isHolder);

            if (!isSyncInProgress) return;

            if (isSuccess) return iotConnectionService.proceedRefreshInfo(isHolder, status, error);

            setConnectInProgress(isHolder, false, customError);

            break;
        case uamFlowTypes.DATA_COLLECTION:
            /*            const isYapSynchronizeDataCollectionInProgress = makeSelectIsYapSynchronizeDataCollectionInProgress()(state);
            const isYapUsageFlowDataCollectionInProgress = makeSelectIsYapUsageFlowDataCollectionInProgress()(state);
            const isDiagnosticFlowDataCollectionInProgress = selectIsDiagnosticFlowDataCollectionInProgress(state);
            const isDataCollectionInProgress =
                isYapSynchronizeDataCollectionInProgress ||
                isYapUsageFlowDataCollectionInProgress ||
                isDiagnosticFlowDataCollectionInProgress;

            if (isDataCollectionInProgress && !isGamBackend) {
                await uamWebSocketResponseService.proceedSynchronizeDataCollection(status, assetId);
                return;
            }*/
            break;
        default:
            break;
    }
};

export default {
    checkRequestStatus,
};
